import * as Config from '../../../config';
import React from 'react';
import Card from './Card';

function CardLoading(props) {
  return <Card title={`Loading...`} type={`LOAD`}
    images={[Config.DEFAULT_IMG]}
    dragEnabled={false} playEnabled={false}
    audio={{}}
    { ...props }
  />
}

export default CardLoading;
